import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _noop from 'lodash/noop';

import IconPattern from '@mlb/react-patterns/components/Icon/icon';
import ButtonPattern from '@mlb/react-patterns/components/Button/button';
import COLORS from '@mlb/react-patterns/style/universal.color';

import Wrapper from '../ModalViewWrapper';
import Message from './Message';

const Icon = styled(IconPattern)`
    circle {
        stroke: ${COLORS.mlbGrey5};
    }
    margin-bottom: 13px;
`;

const Button = styled(ButtonPattern)`
    font-size: 16px;
`;

const Error = (props) => {

    const {
        dictionary,
        onClick,
        lastModalNode,
    } = props;

    const errorMessage = dictionary.reel_error_message || 'There was a problem creating your reel.';
    const buttonText = dictionary.reel_error_button || 'Please try again';

    return (
        <Wrapper>
            <Icon name={'sad-baseball'} width={132} fill={COLORS.mlbGrey5} />
            <Message>{errorMessage}</Message>
            <Button
                ref={lastModalNode}
                handlers={{ onClick }}
                shape={'hollow-borderless'}
                size={'md'}
            >
                {buttonText}
            </Button>
        </Wrapper>
    );

};

export default Error;

Error.propTypes = {
    dictionary: PropTypes.object.isRequired,
    onClick: PropTypes.func,
};

Error.defaultProps = {
    onClick: _noop,
};

